module.exports = __webpack_public_path__ + "static/scalable@2x-b8b007c53da0417abbcd015a762039dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/scalable@2x.png
// module id = 2573
// module chunks = 168707334958949